(()=>{
if (document.documentElement.lang.startsWith('lv')) {
 const localizeReviewButton = () => document.querySelectorAll('.jdgm-widget a, .jdgm-widget button').forEach(button => {
  if (button.textContent.trim() === 'Rakstīt atsauksmi') button.textContent = 'Uzrakstīt atsauksmi';
 });
 const reviewRoot = document.querySelector('main');
 if (reviewRoot) {
  new MutationObserver(localizeReviewButton).observe(reviewRoot, {childList:true,subtree:true});
  localizeReviewButton();
 }
}
const known={
    '6eeb5fcc-1f8b-43f6-b1b7-22244905f0f9': ['Thank you so much! Wonderful service and a fantastic watch. It looks very elegant on the wrist. We will definitely order again. Thank you!', 'Latvian', 'lv'],
    '985dd30b-5773-4110-b1ba-d03bafe7193a': ['Thank you, Chronoera!', 'Latvian', 'lv'],
    '7aa36447-7ce6-4ce0-b2bf-c0937463a16a': ['My watch arrived yesterday and I’m very happy! Delivery took a little longer, but at this price it was definitely worth the wait.', 'Lithuanian', 'lt'],
    '52187f5c-e2b7-49e7-b051-42ff615f02f8': ['Thank you—it arrived within a couple of days. Excellent quality.', 'Latvian', 'lv'],
    '09665c22-74dc-4c30-b73e-ee0959f30a98': ['I really like the watch. It feels comfortable on the wrist. You can see the Swiss quality :)', 'Lithuanian', 'lt'],
    '91fa2c85-cdb4-4ad7-9241-d1dc1f9dacab': ['I gave it to my husband as a gift, and he was very happy!', 'Lithuanian', 'lt'],
    '748e5f51-791a-48d8-9385-3396019059c6': ['The most beautiful watch I’ve ever seen! I’m very happy with my purchase!', 'Lithuanian', 'lt'],
    '11946e3c-b1eb-4b99-a072-7de23a9c5b02': ['I bought it as a gift for my son, and he was very happy!', 'Lithuanian', 'lt'],
    '2f33ee30-d37a-4330-9ae1-2328ca42f32a': ['A very beautiful watch, thank you :)', 'Latvian', 'lv'],
    '66641a6a-0381-4d5b-91c8-e4b03e02c59b': ['Very good quality.', 'Latvian', 'lv'],
    'b9396956-69c5-452a-acf7-605333e7b07a': ['Thank you, we received it :)', 'Latvian', 'lv'],
    '21515354-87f6-41fe-b0f0-63d765a0d57e': ['Great!', 'Lithuanian', 'lt']
  };
Object.assign(known,{"4c23fcef-8b46-4529-8c0d-0ebc88a7835c": ["I bought the watch for my son’s high-school graduation. He really liked the gift. I recommend it!", "Lithuanian", "lt"], "a6c88b7a-bf40-4bc7-ab45-064d6dfcb720": ["A great watch with a beautiful colour — it looks even better in person! I’m very happy with it.", "Lithuanian", "lt"], "48f350a4-1e4f-4010-b2b0-0780deeb7049": ["I ordered the watch as a gift. I have no complaints about the product itself — it is authentic, in impeccable condition, and looks amazing. But the shipping packaging was frankly inadequate. The corners of the branded watch box were dented during delivery, which spoiled the effect of giving the gift.", "Russian", "ru"], "c39cd169-3dfb-49e6-8cf7-8828457fcb6c": ["A great watch!", "Lithuanian", "lt"], "af81ec70-c3ed-4dc4-9f42-92ebfb6ecf72": ["I had to wait five days, but the price was excellent, and so was the quality of the watch.", "Latvian", "lv"]});

if (!customElements.get('chronoera-seastar-reviews')) {
 customElements.define('chronoera-seastar-reviews', class extends HTMLElement {
  connectedCallback() {
   const localeData = JSON.parse(this.querySelector('[data-review-i18n]')?.textContent || '{}');
   const locale = localeData.locale || document.documentElement.lang;
   if (this.observer || !/^(en|lv|lt)(-|$)/.test(locale)) return;
   const labels = Object.fromEntries(Object.entries(localeData.strings || {}).map(([key, value]) => [key, String(value).trim()]));
   const sourceLanguages = {"a31970dd-5773-413e-a2bb-c388600915a2": "en", "f4aa22db-79bf-469a-8d46-2e7e4961e036": "en", "df3a6cb9-b3c4-42bf-b5ef-8fcbb388332b": "en", "7aa36447-7ce6-4ce0-b2bf-c0937463a16a": "lt", "09665c22-74dc-4c30-b73e-ee0959f30a98": "lt", "91fa2c85-cdb4-4ad7-9241-d1dc1f9dacab": "lt", "748e5f51-791a-48d8-9385-3396019059c6": "lt", "11946e3c-b1eb-4b99-a072-7de23a9c5b02": "lt", "21515354-87f6-41fe-b0f0-63d765a0d57e": "lt", "4c23fcef-8b46-4529-8c0d-0ebc88a7835c": "lt", "a6c88b7a-bf40-4bc7-ab45-064d6dfcb720": "lt", "48f350a4-1e4f-4010-b2b0-0780deeb7049": "ru", "c39cd169-3dfb-49e6-8cf7-8828457fcb6c": "lt"};
   const languageLabel = entry => (labels.translated_original || 'Translated from __language__ · View original').replace('__language__', labels['language_' + entry[2]] || entry[1]);
   const handled = new WeakSet();
   const translate = () => {
    if (locale.startsWith('lv')) {
     this.querySelectorAll('.jdgm-title').forEach(title => {
      if (['Klienti mums sako', 'Klienti mums saka'].includes(title.textContent.trim())) title.textContent = 'Ko saka mūsu klienti';
     });
    }
    this.querySelectorAll('.jdgm-card[data-review-id]').forEach(card => {
     if (handled.has(card)) return;
     const id = card.dataset.reviewId;
     if (locale.startsWith('lt') && id === 'a31970dd-5773-413e-a2bb-c388600915a2') return;
     const sourceLanguage = known[id]?.[2] || sourceLanguages[id];
     const entry = /^(lv|lt)(-|$)/.test(locale)
       ? (sourceLanguage && sourceLanguage !== locale.split('-')[0] && labels['body_' + id] && !labels['body_' + id].includes('Translation missing') ? [labels['body_' + id], labels['language_' + sourceLanguage] || sourceLanguage, sourceLanguage] : null)
       : known[id];
     const text = card.querySelector('.jdgm-text > p');
     if (!entry || !text || !text.textContent.trim()) return;
     handled.add(card);
     card.dataset.chEnglish = 'true';
     const original = card.dataset.chOriginal || text.textContent;
     card.dataset.chOriginal = original;
     card.querySelector('.ch-sea-review-language')?.remove();
     const button = document.createElement('button');
     button.type = 'button';
     button.className = 'ch-sea-review-language';
     button.textContent = languageLabel(entry);
     button.setAttribute('aria-expanded','false');
     text.textContent = entry[0];
     text.lang = locale;
     text.after(button);
     button.addEventListener('click', event => {
      event.stopPropagation();
      const showOriginal = button.getAttribute('aria-expanded') !== 'true';
      text.textContent = showOriginal ? original : entry[0];
      text.lang = showOriginal ? entry[2] : locale;
      button.textContent = showOriginal ? (labels.show_translation || 'Show English translation') : languageLabel(entry);
      button.setAttribute('aria-expanded', String(showOriginal));
     });
    });
   };
   this.observer = new MutationObserver(translate);
   this.observer.observe(this,{childList:true,subtree:true});
   translate();
  }
  disconnectedCallback() {this.observer?.disconnect();this.observer=null;}
 });
}
})();



